import { useEffect, useState } from "react";
import { BRAND } from "../lib/brand";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Angelica", href: "#angelica" },
  { label: "The Mark", href: "#mark" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-navy/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 md:px-12 flex items-center justify-between h-20">
        <button
          data-testid="logo-home"
          onClick={() => go("#hero")}
          className="flex items-center gap-3 group"
        >
          <img src={BRAND.prism} alt="Six12 prism" className="h-10 w-10 object-contain" />
          <span className="text-xl tracking-tight font-display">
            <span className="text-white">Six</span>
            <span className="gold-text">12</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm text-slate-300 hover:text-gold transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-btn"
            onClick={() => go("#contact")}
            className="bg-gold text-navy font-semibold uppercase tracking-wider text-sm px-6 py-3 hover:bg-gold-soft transition-colors"
          >
            Book a Consultation
          </button>
        </div>

        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          <div className="space-y-1.5">
            <span className="block w-6 h-0.5 bg-gold" />
            <span className="block w-6 h-0.5 bg-gold" />
            <span className="block w-4 h-0.5 bg-gold" />
          </div>
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-navy/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="block w-full text-left text-slate-200 hover:text-gold py-1"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("#contact")}
            className="w-full bg-gold text-navy font-semibold uppercase tracking-wider text-sm px-6 py-3"
          >
            Book a Consultation
          </button>
        </div>
      )}
    </header>
  );
};
